import React, { useEffect } from 'react';
import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Switch,
} from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useFetch } from 'hooks/useFetch';
import { requiredRule } from 'utils/forms/validationRules';
import { thousandFormatter } from 'utils/forms/formatter';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function OptionsForm({ isActive, onClose, onCreate, onUpdate, initialValues }) {
  const [form] = Form.useForm();
  const [discounts, loading, error] = useFetch(
    'org/v1/discountService/?page=1&size=50',
    []
  );
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (error) {
      message.error('Не удалось загрузить скидки');
    }
  }, [error]);

  useEffect(() => {
    // TODO: get discount id from backend
    if (initialValues) {
      const {
        title,
        title_kz,
        price,
        discount_id,
        isPublic,
        withPromo,
        period,
      } = initialValues;

      form.setFieldsValue({
        title,
        title_kz,
        price,
        discount_id,
        isPublic,
        withPromo,
        period,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      discount_id: values.discount_id === undefined ? null : values.discount_id,
    };

    if (isEditing) {
      onUpdate({ ...payload, id: initialValues?.id }, initialValues?.id);
    } else {
      onCreate(payload);
    }

    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование опции' : 'Создание опции'}
      width="50%"
      onClose={onClose}
      visible={isActive}
    >
      <Form
        form={form}
        initialValues={{ isPublic: true, withPromo: false }}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="title" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Введите наименование" allowClear />
        </Form.Item>

        <Form.Item
          name="title_kz"
          label="Наименование (кз)"
          rules={[requiredRule]}
        >
          <Input placeholder="Введите наименование на казахском" allowClear />
        </Form.Item>

        <Form.Item name="price" label="Цена" rules={[requiredRule]}>
          <InputNumber
            addonAfter="KZT"
            controls={false}
            formatter={thousandFormatter}
            placeholder="Введите цену"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item name="period" label="Период" rules={[requiredRule]}>
          <InputNumber
            addonAfter="дней"
            placeholder="Введите период"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item name="discount_id" label="Скидка (%)">
          <Select placeholder="Выберите скидку" loading={loading} allowClear>
            {discounts?.items?.map(({ id, percent }) => (
              <Select.Option key={id} value={id}>
                {percent} %
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="isPublic" label="Доступен" valuePropName="checked">
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </Form.Item>

        <Form.Item
          name="withPromo"
          label="С промокодом"
          valuePropName="checked"
        >
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { OptionsForm };
